<div class="content">
  <div class="modal-header">
    <h4 class="modal-title full-width ">
      <h3>{{'LABELS.INVOICE_PAY_QA_CODE' | translate}}</h3>
    </h4>
    <button type="button" class="close invoice-timeline-view-close-btn" aria-label="Close"
      (click)="activeModal?.close(null)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row text-center">
      <div class="col">
        <ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="value"
          cssClass="bshadow">
        </ngx-qrcode>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{'LABELS.CLOSE' | translate}}</button>
  </div>
</div>
